export enum HIGHMARK_APP_TYPE {
  AMH = 'hm-allmyhealth',
  IEL = 'highmark-iel',
  BENEFICITY = 'highmark-beneficity',
}
